import { API_BASE_URL } from '../constants';

// Get authentication token from localStorage  
const getAuthToken = () => {
  return localStorage.getItem('token');
};

// Update user's preferred language
export const updateUserLanguage = async (language) => {
  const token = getAuthToken();
  if (!token) {
    throw new Error('User not authenticated');
  }

  const response = await fetch(`${API_BASE_URL}/api/user/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify({ preferredLanguage: language }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

// Check if user is authenticated
export const isUserAuthenticated = () => {
  const token = localStorage.getItem('token');
  return !!token;
};
